import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';

import { ButtonFilterService } from './button-filter.service';

@Component({
    selector: 'pcg-button-filter',
    templateUrl: './button-filter.component.html',
    styleUrls: ['./button-filter.component.scss'],
    standalone: false
})
export class ButtonFilterComponent {
	
	@ViewChild('filterToggle', { static: false }) filterToggle: ElementRef;
	@Input() filterId: string = null!; // Pass through filter id to implement table dropdown filters.

	faIconName = { faFilter };
	
	constructor(public btnFilterService: ButtonFilterService) { }
}